import { useEffect, useRef, useState } from "react";
import { Footer, HeaderNavFAQ } from "../../components/common/index";
import ListsPage from "./ListsPage";
import { ListsRouteContent, ListsRouteWrapper } from "./Lists.styled";

// Owns the whole /Lists route so the footer can sit exactly at the bottom of the
// viewport on a short list, without scrolling and without a dead band underneath.
export default function ListsRoute() {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [minHeight, setMinHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const element = wrapperRef.current;
    if (element == null) {
      return;
    }

    // Let this wrapper, not the shared container, decide the page height.
    document.body.classList.add("lists-route-active");

    // Everything above this wrapper (the page header, the impersonation banner when
    // it's showing, the nav) varies in height, so measure it rather than assume it.
    const measure = () => {
      const distanceFromDocumentTop =
        element.getBoundingClientRect().top + window.scrollY;
      setMinHeight(Math.max(0, window.innerHeight - distanceFromDocumentTop));
    };

    measure();
    window.addEventListener("resize", measure);
    // Re-measure when anything above the wrapper grows or shrinks. Safe from a
    // feedback loop: the measurement depends only on content above the wrapper,
    // so a re-measure after our own height changes produces the same number.
    const observer = new ResizeObserver(measure);
    observer.observe(document.body);

    return () => {
      window.removeEventListener("resize", measure);
      observer.disconnect();
      document.body.classList.remove("lists-route-active");
    };
  }, []);

  return (
    <ListsRouteWrapper ref={wrapperRef} $minHeight={minHeight}>
      <HeaderNavFAQ />
      <ListsRouteContent>
        <ListsPage />
      </ListsRouteContent>
      <Footer />
    </ListsRouteWrapper>
  );
}
